import {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { newServices } from 'services'
import { ExtractPdfItemType, ExtractPdfResponse } from 'services/newServices'
import { OptionCompany } from '../CompareCompanyReport/hook'

export type ArticleSummaryProps = {
  company?: OptionCompany
  selectedNewsId?: string
  baseNewsId?: string
  block?: string
  pdfPage?: string
  isFixHeight?: string
  newsId?: string
  question: string
  height?: string
  onSubmit: () => void
  onEnter: (event: KeyboardEvent<HTMLTextAreaElement>) => void
  onChangeInput: (event: ChangeEvent<HTMLTextAreaElement>) => void
  avatar?: string
  handleSetPagePdf: (e: string, type?: boolean) => void
  clearCache?: boolean
  isDetailModalOpen?: boolean
  onLoadingChange?: (newsId: number | undefined, loading: boolean) => void
}

export const useArticleSummary = (props: ArticleSummaryProps) => {
  const { newsId: id } = props
  const [data, setData] = useState<{
    loading: boolean
    data: ExtractPdfItemType[]
    error: boolean
  }>({ loading: false, data: [], error: false })

  const getSummaryItems = (
    dataPdf?: ExtractPdfResponse | ExtractPdfItemType[] | null,
  ): ExtractPdfItemType[] => {
    if (!dataPdf) return []
    if (Array.isArray(dataPdf)) return dataPdf
    if (Array.isArray(dataPdf.response)) return dataPdf.response
    return []
  }

  const getExtractPdf = useCallback(async () => {
    if (!id) return

    setData(prev => ({ ...prev, loading: true, error: false }))

    try {
      const response = await newServices.addExtractPdf({
        new_id: id.toString(),
        clear_cache: props.clearCache ?? false,
        only_cache: true,
        fe_url: window.location.href,
      })

      if (response.is_success === false && response.message === 'miss_cache') {
        setData(prev => ({ ...prev, loading: false, error: true, data: [] }))
        return
      }

      setData(prev => ({
        ...prev,
        loading: false,
        data: getSummaryItems(response.data as ExtractPdfResponse),
        error: false,
      }))
    } catch {
      setData(prev => ({ ...prev, loading: false, error: true }))
    }
  }, [id, props.clearCache])

  useEffect(() => {
    getExtractPdf()
  }, [getExtractPdf])

  return {
    ...props,
    data,
  }
}
